import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { pageTracking } from '../tracking';
import { selectRegistrations } from '../../containers/Authentification/Registration/selectors';
import { selectActiveProfile, selectUserProfiles, selectUserData } from '../../containers/App/selectors';
import { useTracking } from 'react-tracking';
import { trackPageView } from '../blitzerTracking';
import ReactGA from 'react-ga';

const initialData = {
  preventPageScroll: false,
};

export const PageScrollContext = createContext(initialData);

const PageScrollProvider = props => {
  const activeProfile = useSelector(selectActiveProfile());
  const profiles = useSelector(selectUserProfiles());
  const registrations = useSelector(selectRegistrations());
  const userDetails = useSelector(selectUserData());
  const tracking = useTracking();
  const profile = {
    ...activeProfile,
    allProfileWithAccess: profiles.length,
    registrationCompleteDate: registrations.find(r => r?.profile?.id === activeProfile.id)?.completed_date,
  };
  const [preventPageScroll, setPreventPageScroll] = useState(initialData.preventPageScroll);

  const router = useRouter();
  useEffect(() => {
    const handleRouteChangeComplete = url => {
      const pageInfo = pageTracking({ router, url, profile, userDetails });
      /* Avoid page scroll on first click
       if (!preventPageScroll) {
        window.scrollTo(0, 0);
      }
      */
      tracking.trackEvent(trackPageView(pageInfo));
      if (window && window.Appcues) {
        window.Appcues.page();
      }
      ReactGA.pageview(pageInfo.path);
      setPreventPageScroll(false);
    };

    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    // If the component is unmounted, unsubscribe
    // from the event with the `off` method:
    return () => {
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router]);

  const dataValue = useMemo(() => ({ preventPageScroll, setPreventPageScroll }), [preventPageScroll]);

  return <PageScrollContext.Provider value={dataValue} {...props} />;
};

export const usePageScroll = () => useContext(PageScrollContext);

export default PageScrollProvider;
